import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-declined-modal',
  templateUrl: './payment-declined-modal.component.html',
  styleUrls: ['./payment-declined-modal.component.scss']
})
export class PaymentDeclinedModalComponent implements OnInit {
  error: any;
  constructor() { }

  ngOnInit() {
    this.putMessage()
  }

  putMessage(){
    this.error = sessionStorage.getItem('errorResp')
    console.log(this.error, 'HERE ARE ERROR GET ITEM')
    if(this.error === undefined && this.error === ''){
      this.error = 'Tu pago fue declinado por el banco';
    }
  }

  closeModal(){
    let modalElement = <HTMLElement> document.querySelector('app-payment-declined-modal');
    modalElement.setAttribute('hidden', "");
  }
}
